<template>
  <a-modal v-model="visible11" title="新增易制毒证件" width="1020px" :footer="null">
    <div>
      <div style="height:20px;border-bottom:1px solid #2B9A34;color:#2B9A34;width:160px">易制毒化学品购买许可证</div>
      <a-form-model>
        <a-row class="form-row" :gutter="24">
          <a-col :xl="{span: 12}" :lg="{span: 6}" :md="{span: 12}" :sm="24">
            <a-form-model-item ref="name" label="购货单位" prop="name">
            <a-input v-model="subject" :disabled="true" />
            </a-form-model-item>
          </a-col>
          <a-col :xl="{span: 12}" :lg="{span: 6}" :md="{span: 12}" :sm="24">
            <a-form-model-item ref="name" label="证书编号" prop="name">
            <a-input v-model="number" />
            </a-form-model-item>
          </a-col>
          <a-col :xl="{span: 12}" :lg="{span: 6}" :md="{span: 12}" :sm="24">
            <a-form-model-item ref="name" label="颁发机构" prop="name">
            <a-input v-model="issuingAuthority" />
            </a-form-model-item>
          </a-col>
          <a-col :xl="{span: 12}" :lg="{span: 6}" :md="{span: 12}" :sm="24">
          <a-form-model-item ref="name" label="证书有效期" prop="name">
              <div style="display:flex">
                <a-form-model-item style="width:48%;margin:0 10px 0 0">
                <a-date-picker
                    style="width: 100%;"
                    v-model="startTime"
                    />
                </a-form-model-item>
                <a-form-model-item style="width:48%">
                <a-date-picker
                    style="width: 100%;"
                    v-model="endTime"
                    />
                </a-form-model-item>
              </div>
            </a-form-model-item>
          </a-col>
          <a-col :xl="{span: 24}" :lg="{span: 6}" :md="{span: 12}" :sm="24">
            <a-form-model-item ref="name" label="证书扫描件" prop="name">
              <img-upload
              ref="upload1"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
      <div style="margin:20px 0;">批准购买产品内容</div>
      <div style="width:100%; display: flex;justify-content: space-between;background: #F4F4F4;height:40px;line-height: 40px;padding:0 20px">
        <span>商品名</span>
        <span>CAS号</span>
        <span>批准购买数量</span>
        <span>购买数量</span>
        <span>剩余购买数量</span>
        <span>单位</span>
        <span>有效</span>
        <span style="width:40px">操作</span>
      </div>
        <div style="width:100%; display: flex;justify-content: space-between;height:40px;line-height: 40px;padding:0 20px;margin:10px 0;background:#E8E6E6">
          <a-input style="width:100px;margin-top:4px" :disabled="disabled1" v-model="kongshuju.name" />
          <a-input style="width:100px;margin-top:4px" :disabled="disabled1" v-model="kongshuju.casNum" />
          <a-input style="width:110px;margin-top:4px" :disabled="disabled1" type="number" v-model="kongshuju.quantity" />
          <a-input style="width:110px;margin-top:4px" :disabled="disabled1" type="number" v-model="kongshuju.buyQuantity" />
          <a-input style="width:110px;margin-top:4px" disabled type="number" v-model="kongshuju.residueQuantity" />
          <a-select v-model="kongshuju.unit" default-value="g" :disabled="disabled1" style="width:120px;margin-top:4px">
            <a-select-option v-for="int in list_unit" :key="int" :value="int">{{ int }}</a-select-option>
          </a-select>
          <a-input style="width:100px;margin-top:4px" :disabled="disabled1" type="number" v-model="kongshuju.validNum"  />
          <div>
          <a-button v-if="disabled1 === true" @click="disabled1 = false">修改</a-button>
          <a-button v-else @click="tianjiakong" >保存</a-button>
          <!-- <a-button  @click="crea">清空</a-button> -->
          </div>
        </div>
      <!-- <a-button type="dashed" style="margin:20px 0 30px 0" block>
        添加
      </a-button> -->
      <!-- <div style="height:20px;border-bottom:1px solid #2B9A34;color:#2B9A34;width:160px;margin:20px 0">易制毒化学品运输许可证 </div> -->
      <!-- <a-form-model>
        <a-row class="form-row" :gutter="24">
          <a-col :xl="{span: 12}" :lg="{span: 6}" :md="{span: 12}" :sm="24">
            <a-form-model-item ref="name" label="购买主体" :disabled="true" prop="name">
            <a-input v-model="transportation.subject" :disabled="true" />
            </a-form-model-item>
          </a-col>
          <a-col :xl="{span: 12}" :lg="{span: 6}" :md="{span: 12}" :sm="24">
            <a-form-model-item ref="name" label="证书编号" prop="name">
            <a-input v-model="transportation.number" />
            </a-form-model-item>
          </a-col>
          <a-col :xl="{span: 12}" :lg="{span: 6}" :md="{span: 12}" :sm="24">
            <a-form-model-item ref="name" label="颁发机构" prop="name">
            <a-input v-model="transportation.issuingAuthority" />
            </a-form-model-item>
          </a-col>
          <a-col :xl="{span: 12}" :lg="{span: 6}" :md="{span: 12}" :sm="24">
            <a-form-model-item ref="name" label="证书有效期" prop="name">
              <div style="display:flex">
                <a-form-model-item style="width:48%;margin:0 10px 0 0">
                <a-date-picker
                    style="width: 100%;"
                    v-model="transportation.startTime"
                    />
                </a-form-model-item>
                <a-form-model-item style="width:48%">
                <a-date-picker
                    style="width: 100%;"
                    v-model="transportation.endTime"
                    />
                </a-form-model-item>
              </div>
            </a-form-model-item>
          </a-col>
          <a-col :xl="{span: 12}" :lg="{span: 6}" :md="{span: 12}" :sm="24">
            <a-form-model-item ref="name" label="运输起点" prop="name">
              <div style="display:flex">
                <a-form-model-item style="width:32%;margin:0 10px 0 0">
                  <a-select style="width: 100%;" v-model="transportation.origin.district1" @change="sheng_Change">
                    <a-select-option :key="index" v-for="(item,index) in all_available" :value="item.name">{{ item.name }}</a-select-option>
                  </a-select>
                </a-form-model-item>
                <a-form-model-item style="width:32%;margin:0 10px 0 0">
                  <a-select style="width: 100%;" v-model="transportation.origin.district2" @change="shi_Change">
                    <a-select-option :key="index" v-for="(item,index) in all_shi" :value="item.name">{{ item.name }}</a-select-option>
                  </a-select>
                </a-form-model-item>
                <a-form-model-item style="width:32%">
                  <a-select style="width: 100%;" v-model="transportation.origin.district3" @change="qu_Change">
                    <a-select-option :key="index" v-for="(item,index) in all_qu" :value="item.name">{{ item.name }}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </div>
            </a-form-model-item>
          </a-col>
          <a-col :xl="{span: 12}" :lg="{span: 6}" :md="{span: 12}" :sm="24">
            <a-form-model-item ref="name" label="运输终点" prop="name">
              <div style="display:flex">
                <a-form-model-item style="width:32%;margin:0 10px 0 0">
                  <a-select style="width: 100%;" v-model="transportation.destination.district1" @change="sheng_Change1">
                    <a-select-option :key="index" v-for="(item,index) in all_available" :value="item.name">{{ item.name }}</a-select-option>
                  </a-select>
                </a-form-model-item>
                <a-form-model-item style="width:32%;margin:0 10px 0 0">
                  <a-select style="width: 100%;" v-model="transportation.destination.district2" @change="shi_Change1">
                    <a-select-option :key="index" v-for="(item,index) in all_shi" :value="item.name">{{ item.name }}</a-select-option>
                  </a-select>
                </a-form-model-item>
                <a-form-model-item style="width:32%">
                  <a-select style="width: 100%;" v-model="transportation.destination.district3" @change="qu_Change1">
                    <a-select-option :key="index" v-for="(item,index) in all_qu" :value="item.name">{{ item.name }}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </div>
            </a-form-model-item>
          </a-col>
          <a-col :xl="{span: 24}" :lg="{span: 6}" :md="{span: 12}" :sm="24">
            <a-form-model-item ref="name" label="证书扫描件" prop="name">
              <img-upload
              ref="upload2"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model> -->
      <a-button @click="cun" style="margin-left:450px">
        保存
      </a-button>
    </div>
  </a-modal>
</template>
<script>
import ImgUpload from './ImgUpload'
export default {
  components: {
    ImgUpload
  },
  data() {
    return {
      list_unit: ['ton','kg','g','mg','L','ml'],
      cunshuju:[], //数组存放商品的数据
      disabled1: false,
      kongshuju: {
        unit: '',
        quantity: null,
        name: '',
        casNum: '',
        isdisabled: true,
        validNum: null
      },
      subject: '',
      number: '',
      startTime: '',
      endTime: '',
      issuingAuthority: '',
      scanList: [],
      userId: '',
      // 下面是运输证
      // 运输终点
      transportation: {
        destination:{
          district1: '',
          district1Id:'',
          district2: '',
          district2Id:'',
          district3: '',
          district3Id:'',
        },
        // 运输起点
        origin: {
          district1: '',
          district1Id:'',
          district2: '',
          district2Id:'',
          district3: '',
          district3Id:'',
        },
        startTime: '',
        issuingAuthority: '',
        scanList: [],
        endTime: '',
        subject: '',
      },
      visible11: false,
      all_available: '', // 所有省份
      all_shi: '', // 下级市
      all_qu: '', // 下级区
      provinceId: '',
      province: '',
      cityId: '',
      city: '',
      areaId: '',
      area: ''
    };
  },
  created () {
    const getUserinfo = JSON.parse(localStorage.user_info);
    this.userId = getUserinfo.uuid
    this.api.get_all_available().then((res) => {
      this.all_available = res.data
    })
    this.api.get_companyFullName().then((res) => {
      this.subject = res.data
      this.transportation.subject = res.data
      // if (res.data === null) {
      //   this.$router.push('/enterprise_info')
      //   this.$message.error('请前往企业信息完成内容填写')
      // }
    })
  },
  methods: {
    cun () {
      const img1 = this.$refs['upload1'].list.filter(item => item.id).map(item => {
        return {
          id: item.id
        }
      })
      for (let i = 0; i < img1.length; i++) {
        this.scanList[i] = img1[i].id
      }
      // const img2 = this.$refs['upload2'].list.filter(item => item.id).map(item => {
      //   return {
      //     id: item.id
      //   }
      // })
      // for (let i = 0; i < img2.length; i++) {
      //   this.transportation.scanList[i] = img2[i].id
      // }
      const list = {
        allow: this.kongshuju,
        startTime: this.startTime,
        endTime: this.endTime,
        issuingAuthority: this.issuingAuthority,
        number: this.number,
        scanList :this.scanList,
        subject: this.subject,
        transportation: this.transportation,
        userId: this.userId
      }
      this.api.pushYizhidu_detail(list).then((res) => {
        if (res.ok === true) {
          this.$message.success(res.message)
          this.zhenshuUuid = res.data.uuid
          console.log(this.zhenshuUuid, '新增的证书uuid')
          this.visible11 = false
          this.$emit('child-event', res.data.uuid)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    tianjiakong () {
      this.disabled1 = true
      this.kongshuju.residueQuantity = this.kongshuju.quantity - this.kongshuju.buyQuantity
      // this.cunshuju.push({...this.kongshuju})
      // this.kongshuju.unit = ''
      // this.kongshuju.quantity = null
      // this.kongshuju.name = ''
      // this.kongshuju.casNum = ''
    },
    crea () {
      this.kongshuju.unit = ''
      this.kongshuju.quantity = null
      this.kongshuju.name = ''
      this.kongshuju.casNum = ''
    },
    del (e) {
      this.cunshuju.splice(e, 1);
    },
    // 选择省市区运输起点
    sheng_Change (e) {
      this.province = e
      this.all_available.forEach((element) => {
        if (element.name === e) {
          this.transportation.origin.district1Id = element.id
          this.all_shi = element.children
        }
      })
    },
    shi_Change (e) {
      this.city = e
      this.all_shi.forEach((element) => {
        if (element.name === e) {
          this.transportation.origin.district2Id = element.id
          this.all_qu = element.children
        }
      })
    },
    qu_Change (e) {
      this.area = e
      this.all_qu.forEach((element) => {
        if (element.name === e) {
          this.transportation.origin.district3Id = element.id
          this.all_qu2 = element.children
        }
      })
    },
    // destination
    // 运输终点
    sheng_Change1 (e) {
      this.province = e
      this.all_available.forEach((element) => {
        if (element.name === e) {
          this.transportation.destination.district1Id = element.id
          this.all_shi = element.children
        }
      })
    },
    shi_Change1 (e) {
      this.city = e
      this.all_shi.forEach((element) => {
        if (element.name === e) {
          this.transportation.destination.district2Id = element.id
          this.all_qu = element.children
        }
      })
    },
    qu_Change1 (e) {
      this.area = e
      this.all_qu.forEach((element) => {
        if (element.name === e) {
          this.transportation.destination.district3Id = element.id
          this.all_qu2 = element.children
        }
      })
    },
  },
};
</script>

<style scoped>
   /deep/.ant-form-item{
    margin-bottom: 0px;

  }
</style>



// WEBPACK FOOTER //
// src/components/ImgUpload/XyizhiDu.vue